import Cookies from 'js-cookie'
const TokenKey = 'ols-open-api-'

export function getLang (name) {
  const lang = Cookies.get(TokenKey + name)
  if (lang) {
    return lang
  } else {
    return null
  }
}

export function setLang (name, lang) {
  return Cookies.set(TokenKey + name, lang)
}
